var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "24px",
    viewBox: "0 0 22 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_logout",
    transform: "translate(-1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "log-out-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,5.53163837 C7.92462026,5.53163837 4.60856145,8.84769718 4.60856145,12.9230769 C4.60856145,16.9984567 7.92462026,20.3145155 12,20.3145155 C16.0753797,20.3145155 19.3914386,16.9984567 19.3914386,12.9230769 C19.3914386,8.84769718 16.0753797,5.53163837 12,5.53163837 M12,23.0769231 C6.4011047,23.0769231 1.84615385,18.5219722 1.84615385,12.9230769 C1.84615385,7.32418163 6.4011047,2.76923077 12,2.76923077 C17.5988953,2.76923077 22.1538462,7.32418163 22.1538462,12.9230769 C22.1538462,18.5219722 17.5988953,23.0769231 12,23.0769231",
    id: "Fill-2",
    fill: "#FF3F77"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#8F1225",
    points: "11.0769231 10.1538462 13.8461538 10.1538462 13.8461538 0 11.0769231 0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.cc9a57992198c38c9928161e9b75b625.svg";
export { ForwardRef as ReactComponent };